export default {
  hero_label: 'Philosophy',
  hero_title: 'フィロソフィー',
  hero_subtitle: 'AIとあらゆる事業領域（X）を掛け合わせ、\n企業の変革と持続的な成長を共に実現します。',
  scroll: 'SCROLL',
  mission_label: 'MISSION',
  mission_title: 'ミッション',
  mission_text_1: 'AIとあらゆる事業領域を掛け合わせることで、企業が抱える構造的な課題を解決し、変革と成長を実現する――それが私たちのミッションです。',
  mission_text_2: '戦略立案から実行支援・人材育成まで、すべてのフェーズで専任チームが伴走し、クライアントの事業に本質的な価値をもたらし続けます。',
  vision_label: 'VISION',
  vision_title: 'ビジョン',
  vision_text_1: 'AIが当たり前のビジネスインフラとなる時代において、すべての企業がAIを戦略的に活用し、競争優位を築ける社会の実現を目指しています。',
  vision_text_2: '「AIX」という掛け合わせの思想を世の中に広め、日本企業のAI活用レベルを底上げするリーディングカンパニーとして、業界全体を牽引します。',
  values_label: 'VALUES',
  values_title: 'バリュー',
  values_subtitle: '私たちが大切にしている3つの価値観',
  value_1_title: '変革への挑戦',
  value_1_desc: 'AIとあらゆる事業領域を掛け合わせ、既存の枠組みを超えた変革を追求します。テクノロジーの可能性を最大限に活かし、クライアントと共に未来を切り拓きます。',
  value_2_title: '共創と伴走',
  value_2_desc: 'クライアントの課題を自分ごととして捉え、戦略立案から実行・定着まで一貫して伴走します。真のパートナーとして、長期的な信頼関係の中で共に成長します。',
  value_3_title: '成果への執着',
  value_3_desc: '「導入すること」ではなく「成果を出すこと」にこだわります。KPIの設計から効果測定・改善まで、具体的な事業成果の創出を最優先に考えます。',
  approach_label: 'APPROACH',
  approach_title: '私たちのアプローチ',
  approach_subtitle: 'AIX コンサルティングが大切にしている4つのアプローチ',
  approach_1_num: '01',
  approach_1_title: 'AI×事業の深い理解',
  approach_1_desc: 'クライアントの事業課題・競合環境・組織特性を徹底的に把握した上で、最適なAI活用戦略を設計します。表面的な課題ではなく、構造的な課題解決にこだわります。',
  approach_2_num: '02',
  approach_2_title: '業界横断の知見と実践',
  approach_2_desc: '製造・金融・小売・医療など多様な業界でのAI活用実績を横断的に活かし、業種・規模を問わず最適解を提供します。業界の常識にとらわれない柔軟な発想で臨みます。',
  approach_3_num: '03',
  approach_3_title: '戦略から実行までの一貫支援',
  approach_3_desc: '上流の戦略立案だけで終わらず、実装・導入・運用定着まで一気通貫でサポートします。絵に描いた餅にならないよう、現場視点での実行支援を徹底します。',
  approach_4_num: '04',
  approach_4_title: '自走できる組織への変革',
  approach_4_desc: '支援終了後もクライアントが自律的にAIを活用・改善できるよう、ナレッジ移転・人材育成まで含めた支援を行います。依存ではなく自立を促すパートナーシップを大切にします。',
  cta_title: 'AI活用・DX推進の課題はAIX JAPANにお任せください',
  cta_desc: 'AI戦略の立案から実行支援・人材育成まで、包括的にサポートいたします。\nまずはお気軽にご相談ください。',
  cta_btn: '無料相談・お問い合わせ',
};